import hero1 from "@/assets/hero-1.jpg";
import beautyImg from "@/assets/collection-beauty.jpg";
import homeImg from "@/assets/collection-home.jpg";
import fashionImg from "@/assets/collection-fashion.jpg";
import creator1 from "@/assets/creator-1.jpg";
import creator2 from "@/assets/creator-2.jpg";
import creator3 from "@/assets/creator-3.jpg";
import perfume from "@/assets/product-perfume.jpg";
import sweater from "@/assets/product-sweater.jpg";
import shoes from "@/assets/product-shoes.jpg";
import vase from "@/assets/product-vase.jpg";
import cream from "@/assets/product-cream.jpg";
import necklace from "@/assets/product-necklace.jpg";

const map: Record<string, string> = {
  hero1,
  beauty: beautyImg,
  home: homeImg,
  fashion: fashionImg,
  creator1,
  creator2,
  creator3,
  perfume,
  sweater,
  shoes,
  vase,
  cream,
  necklace,
};

export function resolveImage(key: string | null | undefined): string {
  if (!key) return hero1;
  // Remote URLs (Supabase storage, Unsplash, network images) are returned as-is.
  // We previously routed them through Cloudflare Image Resizing on
  // pluggzofficial.com, but that zone isn't configured for cdn-cgi/image
  // transforms, so the rewrite produced broken images everywhere
  // (preview + production). Use the source URL directly.
  if (key.startsWith("https://") || key.startsWith("http://") || key.startsWith("/")) {
    return key;
  }
  return map[key] ?? key;
}
